import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  margin: 12px 0;

  &:first-child {
    margin-top: 16px;
  }

  &:last-child {
    margin-bottom: 16px;
  }
`;

export const OptionName = styled.span`
  padding: 0 0 0 16px;
  font-size: 14px;
  color: ${ColorPalette.HEX.DimGray};
`;
